import { get } from "./api";

export const getMetricData = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/metricview/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getMetricGraphData = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/metricgraph/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getMvpCashOnHand = (id, signal, params = {}) => {
  const url = `/api/v2/customers/${id}/mvpcashonhand/`;
  return get(url, params, false, signal, true);
};
